// extracted by mini-css-extract-plugin
export var form = "_cg-0";